import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Al montar, verificar si hay una sesión activa (cookie JWT válida)
  useEffect(() => {
    authAPI.verifyToken()
      .then(res => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const res = await authAPI.login({ username, password });
    setUser(res.data);
  };

  const logout = async () => {
    await authAPI.logout();
    setUser(null);
  };

  const isAuthenticated = () => !!user;

  const hasPermission = (permission) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    if (user.role === 'readonly') {
      return permission === 'view';
    }
    return false;
  };

  const isReadOnly = () => user?.role === 'readonly';
  const isAdmin = () => user?.role === 'admin';

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      logout,
      isAuthenticated,
      hasPermission,
      isReadOnly,
      isAdmin
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
